import { ReactNode, useState } from 'react';
import { ShowToast, ToastType, ToastVariant } from '../../types/toast-notification';

export type useToastReturn = {
    isOpen: boolean;
    type?: ToastType;
    message: ReactNode | string;
    show: ShowToast;
    close: VoidFunction;
    closeAfter?: number,
    variant?: ToastVariant;
    className?: string;
};

const useToast = (): useToastReturn => {
    const [isOpen, setIsOpen] = useState(false);
    const [type, setType] = useState<ToastType>('success');
    const [message, setMessage] = useState<ReactNode | string>(null);
    const [variant, setVariant] = useState<ToastVariant>('default');
    const [closeAfter, setCloseAfter] = useState<number>(5000);
    const [className, setClassName] = useState<string>('');

    const show: ShowToast = (type, message, variant, closeAfter, wrapperClassName) => {
        setType(type);
        setMessage(message);
        setVariant(variant ?? 'default');
        setCloseAfter(closeAfter ?? 5000);
        setIsOpen(true);
        setClassName(wrapperClassName ?? '');
    };

    const close = (): void => setIsOpen(false);

    return { isOpen, type, message, show, close, closeAfter, variant, className };
};

export default useToast;
